import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type {} from '@redux-devtools/extension';

import {
  addSource,
  getPrimarySource,
  getSourceConfig,
  getSourceGateway,
  isSourceExist,
  removeSource,
  resetDataSource,
} from './data-sources-store.actions';
import { initialState, STORE_NAME } from './data-sources-store.constant';
import {
  DataSourceStoreActions,
  DataSourceStoreState,
} from './data-sources-store.types';

export const useDataSourcesStore = create<
  DataSourceStoreState & DataSourceStoreActions
>()(
  devtools(
    (set, get) => ({
      ...initialState,
      getPrimarySource: getPrimarySource(get),
      addSource: addSource(set, get),
      getSourceGateway: getSourceGateway(get),
      getSourceConfig: getSourceConfig(get),
      isSourceExist: isSourceExist(get),
      resetDataSource: resetDataSource(set),
      removeSource: removeSource(set, get),
    }),
    { name: STORE_NAME }
  )
);
